import React from 'react';
import { motion } from 'framer-motion';
import { CtaButton } from './CtaButton';
const guarantees = ['Instant Download', 'One-Time Payment', 'Lifetime Access', '7-Day Guarantee'];
export function Hero() {
  return <section className="w-full bg-cream px-5 pb-20 pt-5" data-id="element-107" data-mp="9lla0zpw82ok">
      <div className="mx-auto max-w-4xl text-center" data-id="element-108" data-mp="4lywsqa2emfr">
        <motion.h1 initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="font-display text-[2.6rem] font-black leading-[1.02] tracking-tight text-ink sm:text-6xl md:text-[4.5rem]" data-id="element-109" data-mp="4njrqh0ak7e5">
          Solve a Full Year of Pilates Classes in Just{' '}
          <span className="italic text-brand" data-id="element-110" data-mp="nb6kflpmn9kz">5 Minutes</span>
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.08,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto mt-5 max-w-2xl text-base leading-relaxed text-ink/60 sm:text-lg" data-id="element-111" data-mp="3d21tk0zn2qpb">
          Join 2,000+ instructors who stopped improvising. Walk into every
          session with everything ready to teach, transform, and lead with
          authority.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.97
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.14,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto mt-2 max-w-2xl pb-5 pt-2.5 sm:mt-8" data-id="element-112" data-mp="3e9frdcsh26lo">
          <img src="https://cdn.magicpatterns.com/uploads/u74u1Jpp7uGgkZQhuRaqb1/Diseno-sin-titulo-_92__(1).webp" alt="The PILATES READY pack shown as six printed volumes alongside desktop, tablet and phone versions" className="w-full" data-id="element-113" data-mp="35a2gqgsm3bzd" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.2,
        ease: [0.23, 1, 0.32, 1]
      }} className="-mt-2 sm:mt-8" data-id="element-114" data-mp="2hjymv1586qlk">
          <CtaButton href="#offer" data-id="element-115" data-mp="nbbe31x26h6v" />
          <ul className="mt-6 flex flex-wrap items-center justify-center gap-x-3 gap-y-2 text-xs font-semibold text-ink/50 sm:text-sm" data-id="element-116" data-mp="na9zwokqxekx">
            {guarantees.map((item, index) => <li key={item} className="flex items-center gap-3" data-id="element-117" data-mp="ddwx91783qe1" data-mpi={index}>
                <span data-id="element-118" data-mp="1b0vx1kt7peg5">{item}</span>
                {index < guarantees.length - 1 && <span aria-hidden="true" className="text-ink/25" data-id="element-119" data-mp="1ayjhtfeu9i6s">
                    ·
                  </span>}
              </li>)}
          </ul>
        </motion.div>
      </div>
    </section>;
}